import script from "./CustomerForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerForm.vue?vue&type=script&setup=true&lang=js"

import "./CustomerForm.vue?vue&type=style&index=0&id=3ddf3b45&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ddf3b45"]])

export default __exports__